import getConfig from 'config/public'

const LOCATION_ROOT = getConfig().baseUrl

const getReviewPermalink = (listing, review) => {
  const { cta_urls } = listing
  const { hash_global_review_id: globalReviewId } = review

  return LOCATION_ROOT + cta_urls.detail + 'reviews/' + globalReviewId
}

export default getReviewPermalink
